import { render, staticRenderFns } from "./ComponenteHorno.vue?vue&type=template&id=4c978a91&scoped=true"
import script from "./ComponenteHorno.vue?vue&type=script&lang=js"
export * from "./ComponenteHorno.vue?vue&type=script&lang=js"
import style0 from "./ComponenteHorno.vue?vue&type=style&index=0&id=4c978a91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c978a91",
  null
  
)

export default component.exports